module.exports = __webpack_public_path__ + "96c2b00ed136dc9ec414f0c381011a48.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/project/img/LeBonChoix.jpg
// module id = 485
// module chunks = 0